<template lang="html">

  <section class="home-empresa row-between container ais">

    <div class="contenedor-left">

      <div class="contenedor-home container row-between ais">

        <article class="home-el" v-if="!!procesos" title="Número de ofertas publicadas en este momento">

          <router-link :to="$t('enlaces.mis_ofertas')+'/practicas'" class="enlace-cover"></router-link>

          <h3>OFERTAS<strong>De prácticas</strong></h3>

          <p>Consulta y gestiona las ofertas de prácticas y las candidaturas recibidas.</p>

          <h4 class="bubble" title="Número de ofertas publicadas en este momento">{{procesosPracticasActivos.length}}</h4>

        </article>

        <article class="home-el">

          <router-link :to="$t('enlaces.nueva_oferta')+'/practicas'" class="enlace-cover"></router-link>

          <h3>PUBLICAR<strong>Nueva oferta de prácticas</strong></h3>

          <p>Publica ofertas de prácticas, dirigidas a nuestros candidatos.</p>

          <h4 class="bubble add">+</h4>

        </article>


        <article class="home-el" v-if="!!procesos && !brand.withoutEmpleo" title="Número de ofertas publicadas en este momento">

          <router-link :to="$t('enlaces.mis_ofertas')+'/empleo'" class="enlace-cover"></router-link>

          <h3>OFERTAS<strong>De empleo</strong></h3>

          <p>Consulta y gestiona las ofertas de empleo y las candidaturas recibidas.</p>

          <h4 class="bubble" title="Número de ofertas publicadas en este momento">{{procesosEmpleoActivos.length}}</h4>

        </article>

        <article class="home-el" v-if="!brand.withoutEmpleo">

          <router-link :to="$t('enlaces.nueva_oferta')+'/empleo'" class="enlace-cover"></router-link>

          <h3>PUBLICAR<strong>Nueva oferta de empleo</strong></h3>

          <p>Publica ofertas de prácticas, dirigidas a nuestros egresados/as.</p>

          <h4 class="bubble add">+</h4>

        </article>

      </div>


      <div class="contenedor-programas" v-if="brand.hasProgramaPracticasActivo && brand.hasProgramaPracticasInHome">
        <modulo-programas></modulo-programas>
      </div>

      <div class="contenedor-encuestas">
        <modulo-encuestas></modulo-encuestas>
      </div>

    </div>

    <div class="container -comunicaciones" v-if="comunicaciones.length > 0">
    <div class="contenedor-modulo-comunicaciones" v-if="comunicaciones.length > 0">
      <modulo-comunicaciones ></modulo-comunicaciones>
    </div>
    </div>

    
    

  </section>

</template>

<script lang="js">

  import {mapGetters, mapActions} from 'vuex';

  import moduloEncuestas from '@/components/views/home/modulo-encuestas'

  import moduloComunicaciones from './modulo-comunicaciones';
  import moduloProgramas from './modulo-programas';

  export default  {
    name: 'home-empresa',
    mounted(){
      this.requestProcesos();
    },
    components :{
      'modulo-encuestas' : moduloEncuestas,
      'modulo-comunicaciones' : moduloComunicaciones,
      'modulo-programas' : moduloProgramas,
    },
    methods : {
      ...mapActions(['requestProcesos']),
    },
    computed : {
      ...mapGetters({
        colors : 'basicColors',
        style : 'getStyles',
        procesos : 'getProcesos',
        procesosEmpleo : 'getProcesosEmpleo',
        procesosPracticas : 'getProcesosPracticas',
        comunicaciones : 'getComunicaciones',
        brand : 'getBrand'
      }),
      procesosPracticasActivos : function(){
        let procesos = new Array();
        if(!!this.procesosPracticas){
          procesos = this.procesosPracticas.filter(p => p.idEstado == 2)
        }
        return procesos;
      },
      procesosEmpleoActivos : function(){
        let procesos = new Array();
        if(!!this.procesosEmpleo){
          procesos = this.procesosEmpleo.filter(p => p.idEstado == 2)
        }
        return procesos;
      }
    }
  }
</script>

<style scoped lang="scss">


@import '@/assets/css/colors.scss';

  .home-empresa{
    max-width: 1200px;
    padding-top: 70px;
    min-height: calc(100vh - 309px);
  }

  .contenedor-home{
    padding-bottom: 0px;
    max-width: 800px;
  }

  .home-el  {
    width: calc(50% - 10px);
    max-width: 380px;
    padding: 25px;
    margin-bottom: 50px;
    text-align: left;
    position: relative;

    &:nth-child(3){
      margin-bottom: 0;
    }

    &:nth-child(4){
      margin-bottom: 0;
    }

  }

  .home-el h3{
    font-size: 16px;
    margin-bottom: 10px;
    font-weight: 400;
  }

  .home-el h3 strong{
    width: 100%;
    display: inline-block;
    font-size: 24px;
    font-weight: 800;
  }

  .bubble{
    position: absolute;
    right: 20px;
    top: 0;
    transform: translateY(-50%);
    height: 55px;
    line-height: 55px;
    width: 55px;
    font-weight: 800;
    text-align: center;
    font-size: 21px;
    border-radius: 100%;
  }

  .bubble.add{
    font-size: 36px;
  }

  .container.-comunicaciones{
    width: auto;
  }

  .contenedor-left:first-child:last-child{
    width: 100%;
  }

  @media screen and (max-width: 1185px){
    .home-empresa{
      justify-content: center;
      -webkit-justify-content: center;
    }

    .contenedor-modulo-comunicaciones{
      margin-top: 50px;
      max-width: 768px;
      padding-bottom: 50px;
    }
  }

  @media screen and (max-width: 767px){

    .contenedor-home{
      padding-top: 0px;
      padding-bottom: 25px;
    }

    .home-el{
      max-width: 100%;
      width: 100%;
      &:nth-child(3){
        margin-bottom: 50px;
      }
      &:last-of-type{
        margin-bottom: 0;
      }
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/views/home/home-empresa.vue